import { render } from "./deleteWarn.vue?vue&type=template&id=644caae4&scoped=true"
import script from "./deleteWarn.vue?vue&type=script&lang=js"
export * from "./deleteWarn.vue?vue&type=script&lang=js"

import "./deleteWarn.vue?vue&type=style&index=0&id=644caae4&scoped=true&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644caae4"]])

export default __exports__